import { sanitizeProductName } from './sanitizeProductName';
import { ProductNameProp } from './types';

type GetResourceCenterForProductProps = ProductNameProp;

/**
 * The Tanium Resource Center home page for the given product.
 */
export const getResourceCenterForProduct = ({ productName }: GetResourceCenterForProductProps) => {
  const sanitizedProductName = sanitizeProductName({ productName });
  return `https://help.tanium.com/category/product_${sanitizedProductName}`;
};
